import { FunctionComponent, ReactNode } from 'react';
import * as React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';

type ServiceTemplateProps = {
  isFullWidth?: boolean;
  left: ReactNode;
  right: ReactNode;
  rightOnTop?: boolean;
  leftWidth?: string;
};

const TwoColumnsContainer = styled.div`
  ${tw`flex flex-col lg:flex-row`}
  overflow: hidden;
  /* https://css-tricks.com/fluid-width-equal-height-columns/ */
`;

const Left = styled.div<{ width?: string }>`
  ${tw`flex`}
  min-height: 100%;
  margin: 0;
  width: ${({ width = 'auto' }) => width};
`;

const Right = styled.div`
  ${tw`flex`}
  flex: 1;
`;

const FullWidth = styled.div`
  width: 100vw;
  position: relative;
  margin: 0 -50vw;
  left: 50%;
  right: 50%;
  ${tw`pb-0 md:pb-0`};
`;

const TwoColumnSection: FunctionComponent<ServiceTemplateProps> = ({
  left,
  right,
  isFullWidth = false,
  rightOnTop = false,
  leftWidth,
}) => {
  const { min1024 } = useBreakpoints();
  if (isFullWidth) {
    return (
      <FullWidth>
        <TwoColumnsContainer>
          <Left width={leftWidth}>{left}</Left>
          <Right>{right}</Right>
        </TwoColumnsContainer>
      </FullWidth>
    );
  }
  return (
    <TwoColumnsContainer>
      {rightOnTop ? (
        min1024 ? (
          <>
            <Left width={leftWidth}>{left}</Left>
            <Right>{right}</Right>
          </>
        ) : (
          <>
            <Right>{right}</Right>
            <Left width={leftWidth}>{left}</Left>
          </>
        )
      ) : (
        <>
          <Left width={leftWidth}>{left}</Left>
          <Right>{right}</Right>
        </>
      )}
    </TwoColumnsContainer>
  );
};

export default TwoColumnSection;
